import React from 'react'

export type InputSize = 'sm' | 'md'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputSize?: InputSize
  invalid?: boolean
}

const BASE_INPUT_CLASS = 'min-w-0 w-full rounded border border-[#CBD5E1] bg-white text-sm text-gray-700 outline-none transition-colors placeholder:text-gray-400 focus:border-[#1D74D8] focus:ring-1 focus:ring-[#1D74D8] disabled:cursor-not-allowed disabled:bg-[#F8FAFC] disabled:text-gray-400'

function getInputSizeClass(inputSize: InputSize): string {
  return inputSize === 'md'
    ? 'px-3 py-2'
    : 'px-2 py-1.5'
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className = '',
  inputSize = 'sm',
  invalid = false,
  ...props
}, ref) => (
  <input
    ref={ref}
    aria-invalid={invalid || undefined}
    className={`${BASE_INPUT_CLASS} ${getInputSizeClass(inputSize)}${invalid ? ' border-[#B3261E] focus:border-[#B3261E] focus:ring-[#B3261E]' : ''}${className ? ` ${className}` : ''}`}
    {...props}
  />
))

Input.displayName = 'Input'

export default Input
